(function(window, undefined) {

    'use strict';

    /**
     * resolves video redirect
     */

    //var cors = SAPO.Utility.cors;
    var jsonpCORS   = SAPO.Utility.jsonpCORS;

    // Uncomment line below after SV has full HTTPS support
    var pageProtocol = SAPO.Project.Video.Features.pageProtocol();

    SAPO.Project.Video.sapoVideosVideoSource = function(uri, cb) {
        //console.log('REQUESTING VIDEO SOURCE FOR ' + uri);
        var sep = (uri.lastIndexOf('?') === -1) ? '?' : '&';

        // Uncomment line below after SV has full HTTPS support
        uri = uri.replace(/^http:|^https:/, pageProtocol);

        var hashIndex = uri.lastIndexOf('#'); // remove hash from redirect
        if (hashIndex !== -1) {
            //console.log(uri);
            uri = uri.substring(0, hashIndex);
            //console.log(uri);
        }

        if (uri.indexOf('/mov/24') !== -1) {
            //console.log('REQUESTING LIVE VIDEO URL');

            jsonpCORS(
                [uri, 'all=1'].join(sep),
                function(data) { // OK
                    //console.log(data);
                    cb(null, data);
                },
                function() { // ERR
                    cb('Error fetching video source!', '');
                },
                5 // timeout in secs
            );

            // TODO TEMP PATCH
            /*setTimeout(function() {
                cb(null, {
                    hls:  'http://10.134.130.222:5080/hlsapp/teststream.m3u8',
                    rtmp: 'rtmp://10.134.130.222/hlsapp/teststream'
                });
            }, 500);*/
        }
        else {
            //console.log('REQUESTING STATIC VIDEO URL');

            var onOk = function(data) { // OK
                //console.log(data.url);
                cb(null, data.url);
            };

            var onErr = function() { // ERR
                cb('Error fetching video source!', '');
            };

            uri = [uri, 'videosrc=true'].join(sep);

            jsonpCORS(
                uri,   // url
                onOk,  // onOk
                onErr, // onErr
                5      // timeout in secs
            );
        }
    };

})(window);
